import { ALLOWED_PORTAL_URLS, COUNTRY_MAP, IS_ON_IFRAME } from '../constants';
import { usePortalContext } from '../services';
export const countryCode = (countryName) => Object.keys(COUNTRY_MAP).find(k => COUNTRY_MAP[k] === countryName);
export const parentPostMessage = (scope) => (message) => {
    if (IS_ON_IFRAME) {
        console.log(scope, 'SEND MESSAGE', message, `${window.location.protocol}//${window.location.host}`);
        window.parent.postMessage(message, Array.isArray(ALLOWED_PORTAL_URLS) ? '*' : ALLOWED_PORTAL_URLS[0]);
    }
};
export const camelToSnakeCase = (key) => {
    return key.replace(/(?<!^)[A-Z]/g, match => `_${match.toLowerCase()}`).toLowerCase();
};
export const getCountryBaseUrl = (countryName) => {
    const { baseUrl, country } = usePortalContext();
    if (!baseUrl)
        return;
    const newCountryCode = countryCode(countryName);
    const currentCountryCode = country.code;
    const regex = new RegExp(`(?<=\/)(?:${currentCountryCode})(?=\/)`, 'i');
    if (currentCountryCode !== newCountryCode) {
        return baseUrl.replace(regex, `${newCountryCode}`).toLowerCase();
    }
    return baseUrl;
};
export const removeSearch = (inputString) => {
    const index = inputString.indexOf('?');
    return index !== -1 ? inputString.slice(0, index) : inputString;
};
